import { BookOpenIcon } from "@heroicons/react/16/solid"

export const LessonBadge = ({ title, onClick }: { title: string; onClick?: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={!onClick}
    title={title}
    className="group inline-flex items-center gap-1.5 mb-1.5 pl-1 pr-2.5 py-1 rounded-full bg-gradient-to-r from-indigo-50 to-violet-50 ring-1 ring-indigo-100 hover:ring-indigo-300 hover:shadow-md hover:shadow-indigo-100 hover:-translate-y-px transition-all disabled:cursor-default disabled:hover:translate-y-0 max-w-full"
  >
    <span className="relative w-4 h-4 flex-shrink-0">
      <span className="absolute inset-0 rounded-full bg-indigo-400 opacity-0 group-hover:opacity-40 group-hover:animate-ping" />
      <span className="relative w-4 h-4 rounded-full bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center group-hover:scale-110 transition-transform">
        <BookOpenIcon className="w-2.5 h-2.5 text-white" />
      </span>
    </span>
    <span className="text-[11px] font-semibold bg-gradient-to-r from-indigo-700 to-violet-700 bg-clip-text text-transparent truncate">
      {title}
    </span>
  </button>
)
